import {Component, HostListener, Inject, NgZone, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {HymnSelectionService} from "../../service/hymn-selection.service";
import {MatListItem, MatListModule} from "@angular/material/list";
import {SettingsService} from "../../service/settings.service";
import {NgIf} from "@angular/common";
import {translation} from "../../translation";

@Component({
  selector: 'app-shortcuts',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatDialogModule, MatListModule, MatListItem, NgIf],
  templateUrl: './shortcuts.component.html',
  styleUrl: './shortcuts.component.scss'
})
export class ShortcutsComponent {

  presentationMode = this.settingsService.getHymnViewMode() == this.settingsService.PRESENTATION;

  constructor(
    protected settingsService: SettingsService,
    public dialogRef: MatDialogRef<ShortcutsComponent>,
    private hymnSelectionService: HymnSelectionService) {}

  protected readonly translation = translation;
}
